import { render, staticRenderFns } from "./GalleryImages.vue?vue&type=template&id=f5bdd44e&scoped=true&lang=html&"
import script from "./GalleryImages.vue?vue&type=script&lang=js&"
export * from "./GalleryImages.vue?vue&type=script&lang=js&"
import style0 from "./GalleryImages.vue?vue&type=style&index=0&id=f5bdd44e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bdd44e",
  null
  
)

export default component.exports